import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/sign-in/passkey')({
  component: PasskeyPlaceholder,
});

// Passkeys are optional per spec §5.1 ("passkeys optional") — the route
// exists so the sign-in flow's structure is settled, but the WebAuthn
// enrolment itself is out of scope for M2.
//
// F3 / Ian's decision 8 (2026-09-28): TOTP is MANDATORY for owners even when
// they sign in with a passkey — settlement changes and cancellations are
// gated on an authenticator-app code (AAL2), which a passkey does not
// replace. Copy only; no logic change.
export const PASSKEY_TOTP_NOTICE =
  'A passkey does not replace your authenticator app. As an owner you must also set up an authenticator app (TOTP): NamibiaGo asks for a code from it before you change your settlement details and before you cancel a booking.';

function PasskeyPlaceholder() {
  return (
    <section className="mx-auto max-w-sm rounded-card border border-border bg-surface p-xl shadow-card">
      <h1 className="text-h2 font-extrabold text-ink">Sign in with a passkey</h1>
      <p className="mt-sm text-body text-ink-2">Passkey sign-in is coming later. Use email and password for now.</p>
      <p className="mt-md text-body font-semibold text-ink" role="note">
        {PASSKEY_TOTP_NOTICE}
      </p>
    </section>
  );
}
